<div class="desktop-full-screen-overlay--flex">
  <div class="dialog__container withdraw-with-document-container">
    <app-form-container
      [title]="'webPos.WithdrawWithDocument' | translate"
      (onCancel)="close()"
      (onSubmit)="handleSubmit()"
      [confirmDisabled]="!isConfirmed() && isSubmitDisabled"
      #formContainer>
      @if (!isConfirmed()) {
        <ng-container form-body>
          <form [formGroup]="form" class="withdraw-with-document fin-doc">
            <div class="header-row">
              <span>{{ 'webPos.ItemName' | translate }}<span class="required-marker">*</span></span>
              <span>{{ 'webPos.VAT' | translate }}<span class="required-marker">*</span></span>
              <span>{{ 'webPos.Reason' | translate }}<span class="required-marker">*</span></span>
              <span>{{ 'webPos.Price' | translate }}<span class="required-marker">*</span></span>
              <span></span>
              <span></span>
            </div>

            <div class="rows" #scrollContainer formArrayName="rows">
              @for (rowCtrl of rows.controls; track rowCtrl; let i = $index) {
                <div class="row" [formGroupName]="i" [class.selected]="selectedRowIndex === i">
                  <div (click)="selectRow(i)">
                    <app-form-input
                      class="field"
                      [label]="''"
                      [placeholder]="'webPos.ItemName' | translate"
                      [type]="FormInputType.Text"
                      formControlName="name">
                    </app-form-input>
                  </div>

                  <div (click)="selectRow(i)">
                    <app-dropdown
                      class="field vat"
                      [label]="''"
                      formControlName="vat"
                      [options]="vatOptions | async"
                      [hideRequiredSign]="true">
                    </app-dropdown>
                  </div>

                  <div (click)="selectRow(i)">
                    <app-dropdown
                      class="field"
                      [label]="''"
                      [options]="reasonOptions"
                      formControlName="reason"
                      [hideRequiredSign]="true">
                    </app-dropdown>
                  </div>

                  <div (click)="selectRow(i)">
                    <app-form-input
                      class="field price"
                      [label]="''"
                      [placeholder]="'webPos.Price' | translate"
                      [type]="FormInputType.Number"
                      formControlName="value">
                    </app-form-input>
                  </div>

                  <button
                    type="button"
                    class="icon-button"
                    (click)="addRow()"
                    [disabled]="!((rows.length - 1) === i)"
                    [attr.aria-label]="'webPos.Global.AddRow' | translate"
                    [attr.title]="'webPos.Global.AddRow' | translate">
                    <fa-icon [icon]="['fas', 'circle-plus']"></fa-icon>
                  </button>

                  <button
                    type="button"
                    class="icon-button"
                    [disabled]="rows.length <= 1"
                    (click)="removeRow(i)"
                    [attr.aria-label]="'webPos.Global.RemoveRow' | translate"
                    [attr.title]="'webPos.Global.RemoveRow' | translate">
                    <fa-icon [icon]="['fas', 'trash']"></fa-icon>
                  </button>
                </div>
              }
            </div>

            <div class="summary-row">
              <span>{{ 'webPos.Global.Summary' | translate }}</span>
              <span>{{ checkSumValue | hcurrency : (loginService.user?.CurrencyCode) }}</span>
            </div>

            @if (availableAmount !== null) {
              <div class="available-amount" [class.insufficient]="amountInsufficient">
                {{ 'webPos.AvailableValue' | translate }}: {{ availableAmount | hcurrency :
                (loginService.user?.CurrencyCode) }}
              </div>
              @if (amountInsufficient) {
                <div class="available-amount">
                  <div class="error">
                  {{ 'webPos.Errors.InsufficientValue' | translate }}
                  </div>
                </div>
              }
            }

            <!-- <div class="note">
              <app-form-input class="field" [label]="'webPos.note' | translate"
                [placeholder]="''" [type]="FormInputType.Text" formControlName="note"></app-form-input>
            </div> -->
          </form>
        </ng-container>
      } @else {
        <ng-container form-body>
          <div class="withdraw-with-document fin-doc">
            <div class="header-row confirmed">
              <span>{{ 'webPos.ItemName' | translate }}</span>
              <span>{{ 'webPos.VAT' | translate }}</span>
              <span>{{ 'webPos.Reason' | translate }}</span>
              <span>{{ 'webPos.Price' | translate }}</span>
              <span></span>
            </div>

            <div class="rows">
              @for (rowCtrl of confirmedTransactions(); track rowCtrl; let i = $index) {
                <div class="row confirmed" [class.selected]="selectedRowIndex === i" (click)="selectRow(i)">
                  <div>
                    <app-form-input
                      class="field"
                      [label]="''"
                      [disabled]="true"
                      [placeholder]="'webPos.ItemName' | translate"
                      [type]="FormInputType.Text"
                      [value]="rowCtrl.name">
                    </app-form-input>
                  </div>

                  <div>
                    <app-dropdown
                      class="field vat"
                      [label]="''"
                      [disabled]="true"
                      [value]="rowCtrl.vat"
                      [options]="vatOptions | async"
                      [hideRequiredSign]="true">
                    </app-dropdown>
                  </div>

                  <div>
                    <app-dropdown
                      class="field"
                      [label]="''"
                      [options]="reasonOptions"
                      [disabled]="true"
                      [value]="rowCtrl.reason"
                      [hideRequiredSign]="true">
                    </app-dropdown>
                  </div>

                  <div>
                    <app-form-input
                      class="field price"
                      [label]="''"
                      [placeholder]="'webPos.Price' | translate"
                      [type]="FormInputType.Number"
                      [disabled]="true"
                      [value]="rowCtrl.value">
                    </app-form-input>
                  </div>

                  <button
                    type="button"
                    class="print-button"
                    (click)="printTransaction(i); $event.stopPropagation()"
                    [disabled]="printingRowIndex !== null"
                    [attr.aria-label]="'webPos.Global.Print' | translate"
                    [attr.title]="'webPos.Global.Print' | translate">
                    <fa-icon class="print-button-icon" [icon]="['fas', 'print']"></fa-icon>
                  </button>
                </div>
              }
            </div>
          </div>
        </ng-container>
      }
    </app-form-container>
  </div>
</div>